export default __webpack_public_path__ + "831deafaf721360989f4a44abbe71478.svg";